import script from "./PUR02_035RPT.vue?vue&type=script&setup=true&lang=js"
export * from "./PUR02_035RPT.vue?vue&type=script&setup=true&lang=js"

import "./PUR02_035RPT.vue?vue&type=style&index=0&id=c28f3212&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c28f3212"]])

export default __exports__